import { Provider } from '@angular/core';
import { EntitlementQuery } from '@examdojo/billing';
import { ENTITLEMENT_SOURCE, EntitlementService } from '@examdojo/core/entitlement';

export function provideEntitlements(): Provider[] {
  return [
    {
      provide: ENTITLEMENT_SOURCE,
      useFactory: (entitlementQuery: EntitlementQuery) => entitlementQuery.entitlements$,
      deps: [EntitlementQuery],
    },
    EntitlementService,
  ];
}
